import React, { ReactNode } from 'react';
import {
  Banner,
  Divider,
  ZonedTime,
  Text,
  Gap,
  Gutter,
} from '@common/components';
import { StateBadge } from 'works/legacy/components/state-badge';
import { OfferState } from '@common/graphql/schema';

const STATUS_MAP = {
  accepted: {
    label: 'Accepted!',
    color: 'grass-darkest',
  },
  change_requested: {
    label: 'Offer Change Requested',
    color: 'grass',
  },
  offered: {
    label: 'Offer',
    color: 'grass',
  },
  rejected: {
    label: 'Offer Rejected',
    color: 'coral',
  },
  retracted: {
    label: 'Offer Retracted',
    color: 'harvest-gold',
  },
};

type OfferType = {
  state: string;
  stateChangedAt: string;
  rejectionReason?: string | null;
  rejectionDetails?: string | null;
};

export function OfferInfoHeader({
  offer,
  headerSlot,
  candidateFullName,
  doNotRehire,
}: {
  offer: OfferType;
  headerSlot: ReactNode;
  candidateFullName: string;
  doNotRehire?: boolean;
}) {
  const isOfferValid = !!offer;
  const offerStateLabel = isOfferValid
    ? STATUS_MAP[offer.state as OfferState]?.label
    : '';
  const offerStateColor = isOfferValid
    ? STATUS_MAP[offer.state as OfferState]?.color
    : '';

  return (
    <div className="offer-info-header">
      <div className="offer-info-header__content">
        {isOfferValid && (
          <div className="offer-info-header__state">
            <StateBadge
              state={offerStateLabel}
              color={offerStateColor}
              rejectionReason={offer.rejectionReason ?? undefined}
              rejectionDetails={offer.rejectionDetails ?? undefined}
              caption={
                <ZonedTime date={offer.stateChangedAt} variant="long_format" />
              }
            />

            <Divider gutter={16} />
          </div>
        )}
        <Gap vertical size="md">
          {doNotRehire && (
            <Banner type="warning">
              Please note, this candidate&apos;s status is &quot;Do Not
              Rehire&quot;.
            </Banner>
          )}
          <div>
            We are delighted to extend this offer to{' '}
            <Text bold>{candidateFullName}</Text>.
          </div>
        </Gap>
      </div>
      {headerSlot && (
        <Gutter direction="top" size="md">
          {headerSlot}
        </Gutter>
      )}
      <Divider gutter={16} />
    </div>
  );
}
